import constants from '../constants.js';
const { LEGACY_ROLES } = constants;

export default function getHighestLegacyRole(roles) {
  if (!roles) return undefined;

  if (roles.includes(LEGACY_ROLES.ADMIN)) return LEGACY_ROLES.ADMIN;
  if (roles.includes(LEGACY_ROLES.CONSULTANT)) return LEGACY_ROLES.CONSULTANT;
  if (roles.includes(LEGACY_ROLES.DEMO)) return LEGACY_ROLES.DEMO;
  if (roles.includes(LEGACY_ROLES.CLIENT_MANAGER)) return LEGACY_ROLES.CLIENT_MANAGER;
  if (roles.includes(LEGACY_ROLES.TRAVEL_ARRANGER)) return LEGACY_ROLES.TRAVEL_ARRANGER;
  if (roles.includes(LEGACY_ROLES.TRAVELLER)) return LEGACY_ROLES.TRAVELLER;

  return null;
}
